import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button,
    FormGroup,
    Input,
    Form
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.jsx';
import { useSelector, useDispatch } from 'react-redux';


import { addRevenueCenter, updateRevenueCenter } from '../../redux/actions/revenueCenterAction';



const AddUpdateRevenueCenter = props => {
    const { history, match } = props;

    const currentId = match.params.id || null;

    const dispatch = useDispatch();

    const { revenueCenter } = useSelector(state => {
        return {
            revenueCenter: state.revenueCenter
        }
    });

    const [isSaving, setIsSaving] = useState(false);

    const [revenueCenterDetails, setRevenueCenterDetails] = useState(null);


    useEffect(() => {
        if (currentId) {
            const currentRevenueCenter = revenueCenter.list.find(item => item._id === currentId);
            setRevenueCenterDetails(currentRevenueCenter);
        }

      
    }, [currentId, revenueCenter.list]);



    const handleInput = e => {

        const { name, value } = e.target;
        setRevenueCenterDetails({
            ...(revenueCenterDetails || {}),
            [name]: value
        })
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        const payload = {
            ...(revenueCenterDetails || {}),
            name: revenueCenterDetails.name
        };

        if (currentId) {
            dispatch(updateRevenueCenter(payload));
            setTimeout(() => {
                setIsSaving(false);
            }, 1500);
        }
        else {
            dispatch(addRevenueCenter(payload));

            setTimeout(() => {
                setIsSaving(false);
                history.push(`/admin/revenuecenter`);
            }, 1500);
        }

    };


    return (
        <>
            <Header />
            {/* Page content */}
            <Container className="mt--7" fluid>
                <Row className="mt-5">
                    <Col className="mb-5 mb-xl-0" xl="12">
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <Row className="align-items-center">
                                    <div className="col">
                                        <h3 className="mb-0">{currentId ? 'Update' : 'Add'} Revenue Center</h3>
                                    </div>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <div className="pl-lg-4">

                                        <Row>
                                            <Col lg="4">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-hours"
                                                    >
                                                        Name
                                                    </label>

                                                    <Input
                                                        name="name"
                                                        className="form-control-alternative"
                                                        placeholder=""
                                                        onChange={handleInput}
                                                        value={revenueCenterDetails && revenueCenterDetails.name}
                                                    />
                                                </FormGroup>

                                            </Col>

                                        </Row>


                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <Button
                                                        disabled={isSaving}
                                                        className="form-control-alternative"
                                                        color="info"
                                                    >
                                                        {isSaving ? 'Please Wait...' : 'Save'}
                                                    </Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );


}


export default withRouter(AddUpdateRevenueCenter);